import { RolesEnum } from "@finway-group/shared/lib/models"

export enum NavbarMenuItemEnum {
    PURCHASED_REQUEST = "purchase_request",
    INVOICE_REQUEST = "invoice_request",
    REIMBURSEMENT_REQUEST = "reimbursement_request",
    SUBSCRIPTION = "subscription",
    EMPLOYEE = "employee",
    COST_CENTER = "costCenter",
    VENDOR = "vendor",
    LOGOUT = "logout",
    BUG_REPORT = "bugReport",
    HELP_CENTER = "helpCenter",
}

export interface MenuItemInterface {
    link: string
    label: string
    canView?: RolesEnum[]
}
